import { DSNCTrustUs } from 'shared-definitions/types'
import { ApiComponentTrustUs } from '../types.wp'
import { imageMapper } from './imageMapper'
import { PLinkMapperOpts, pLinkMapper } from './pLinkMapper'

export function ncTrustUs(input: ApiComponentTrustUs, opts: PLinkMapperOpts): DSNCTrustUs {
  return {
    resource: 'nc-trust-us',
    title: input.title,
    logoImage: imageMapper(input.image, opts),
    pLink: pLinkMapper(input.link, opts),
    achievements: [
      {
        title: input.experience_text,
        metric: input.experience_value,
      },
      {
        title: input.reviewers_text,
        metric: input.reviewers_value,
      },
      {
        title: input.lab_space_text,
        metric: input.lab_space_value,
      },
    ],
    description: {
      image: imageMapper(input.details_image, opts),
      textHtml: input.details,
    },
  }
}
